module.exports = __webpack_public_path__ + "img/50.4a0fd300.jpg";